import {comparemessage} from './comparemessage';

const $ = require('jquery');
import Swiper, {Navigation, Autoplay, Thumbs, Pagination} from 'swiper';

Swiper.use([Navigation, Autoplay, Thumbs, Pagination]);
require('jquery-nice-select');


//Удалить из сравнения
$(document).on('click', '.rbm_js_del_compare_good', function (e) {
    e.preventDefault();
    e.stopPropagation();

    let btnCompare = $(this);
    let categoryCont = btnCompare.closest(".js_compare_container");
    let category = categoryCont.data('category');
    let nav = $(`.js_compare_navigator[data-category="${category}"]`);

    let id = $(this).data('id');
    let output = {
        id: $(this).data('id'),
        key: 'del_compare'
    };
    $.ajax({
        dataType: 'json',
        type: 'POST',
        url: '/includes/modules/compare/compare_function.php',
        data: {'data': JSON.stringify(output)},
        success: function (msg) {
            if (msg.error === 'ok') {
                $(".addtocompare[data-id='" + id + "']").removeClass('active');
                let currentSlide = btnCompare.closest(".rbm_js_product_item");
                currentSlide.remove();

                if (!$('.main-compare-body').find('.rbm_js_product_item').length) {
                    document.location.href = '/compare.html';
                } else if (!categoryCont.find('.rbm_js_product_item').length) {
                    categoryCont.remove();
                    nav.remove();

                    $(`[name="compare_category"] option[value="${category}"]`).remove();
                    $(`[name="compare_category"]`).prop('selectedIndex', 0).trigger('change').niceSelect('update');
                }

                $(".rbm_js_count_compare").html(msg.count_1);
                $(".rbm_js_count_compare_full").html(msg.count_2);
            } else {
                comparemessage('.RBM_alerts', 'Товар удалить из сравнения не удалось.', '<h3>Обнаружена ошибка!</h3>');
            }
        },
        error: function () {
            comparemessage('.RBM_alerts', 'Товар удалить из сравнения не удалось.', '<h3>Обнаружена ошибка!</h3>');
        }
    });
    return false;
});

// Очистить текущую категорию в сравнении
$(document).on('click', '.rbm_js_clear_compare', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var category = $('.rbm_js_change_compare_category').val(),
        categoryCont = $('.rbm_js_compare_category[data-id="' + category + '"]'),
        cont = categoryCont.parents('.rbm_js_compare_container');
    fancyConfirm({
        title: "Вы уверены, что хотите убрать все товары из сравнения?",
        message: "",
        okButton: "Да",
        noButton: "Нет",
        callback: function (value) {
            if (value) {
                var output = {
                    key: 'clear_compare',
                    category: category
                };
                $.ajax({
                    dataType: 'json',
                    type: 'POST',
                    url: '/includes/modules/compare/compare_function.php',
                    data: {'data': JSON.stringify(output)},
                    success: function (theResponse) {
                        if (theResponse.error === 'error') {
                            comparemessage('.RBM_alerts', 'Попробуйте ещё раз.', '<h3>Обнаружена ошибка!</h3>');
                        } else if (theResponse.error === 'ok') {
                            document.location.href = "/compare.html";
                        }
                    },
                    error: function () {
                        comparemessage('.RBM_alerts', 'Попробуйте ещё раз.', '<h3>Ошибка при очистке</h3>');
                    }
                });
                $(this).dialog('close');
            }
        }
    });
});
$('.js_compare_container').each(function (e, i) {
    let currentCategory = this.dataset.category;
    let currentNavigation = document.querySelector(`.js_compare_navigator[data-category="${currentCategory}"]`);
    let navigation = {};
    if (currentNavigation) {
        let next = currentNavigation.querySelector('.swiper-compare-next');
        let prev = currentNavigation.querySelector('.swiper-compare-prev');
        navigation = {
            nextEl: next,
            prevEl: prev,
        }
    }
    new Swiper(this, {
        spaceBetween: 10,
        slidesPerView: 1,
        navigation: navigation,
        watchSlidesVisibility: true,
        slideActiveClass: "active",
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1385: {
                slidesPerView: 4,
                spaceBetween: 30
            }
        }
    })
});
function compare() {

    /*let maxHeight = 0;
    document.querySelectorAll(".production-cart").forEach(item => {
        if (item.offsetHeight > maxHeight) {
            maxHeight = item.offsetHeight;
        }
    })
    document.querySelector('.main-compare-filter').style.height = maxHeight + 'px';*/

    const liAutoHeight = () => {
        let map = new Map();

        document.querySelectorAll('.js_compare_row').forEach(item => {
            let parameterId = item.dataset.parameter_id;
            let t = map.get(parameterId) || [];
            t.push(Math.floor(parseFloat(getComputedStyle(item).height) || 0))
            map.set(parameterId, t)
        })

        let keys = Array.from(map.keys());
        keys.map(item => {
            let arr = map.get(item);
            let max = Math.max(...arr)
            document.querySelectorAll(`.js_compare_row[data-parameter_id="${item}"]`).forEach(i => {
                if (max > 0) {
                    i.style.height = max + 'px';
                }
            })
        })
    }

    liAutoHeight();

    $(window).on("resize", function () {
        liAutoHeight()
    })
}

// Показать другую категорию в сравнении
$(document).on('change', '[name="compare_category"]', function () {
    let currentCategory = this.value;
    $('[name="compare_equal"]').prop('selectedIndex', 0).niceSelect('update').trigger('change');
    $(`.js_compare_navigator, .js_compare_container`).hide();
    $(`.js_compare_navigator[data-category="${currentCategory}"], .js_compare_container[data-category="${currentCategory}"]`).show();
});

// Скрыть/показать одинаковые параметры у товаров в сранении
$(document).on('change', '[name="compare_equal"]', function (e, i) {
    let currentCategory = $('[name="compare_category"]').val();
    let container = $(`.js_compare_container[data-category="${currentCategory}"]`);
    let rows = container.find(`.js_compare_row`);
    rows.hide().removeClass('main-compare-body-table-row').css('background', '');

    switch (parseInt(e.target.value)) {
        case 0:
            $(`.js_compare_container[data-category="${currentCategory}"] .js_compare_row[data-diff="0"]`).addClass('main-compare-body-table-row').show();
            break;
        case 1:
            $(`.js_compare_container[data-category="${currentCategory}"] .js_compare_row[data-diff="1"]`).addClass('main-compare-body-table-row').show();
            break;
        default:
            rows.addClass('main-compare-body-table-row').show();
    }

    setTimeout(compare.bind(null), 500)
    setTimeout(setBackground.bind(null, container), 600)
    setTimeout(eqHeight.bind(null), 500)
});

function setBackground(container) {

    $('.js_compare_options .main-compare-body-table-row:visible').each((j, item2) => {
        if (!(j % 2)) {
            $(item2).css({'background': '#f5f5f5'})
        }
    })

    container.find('.rbm_js_product_item').each((i, item) => {
        $(item).find('.main-compare-body-table-row:visible').each((j, item2) => {
            if (!(j % 2)) {
                $(item2).css({'background': '#f5f5f5'})
            }
        })
    })
}
function eqHeight() {
    let items = $("[data-eqheight]");
  
    items.height("auto");
  
    let maxHeight = Math.max.apply(null, items.map(
      function(){
        return $(this).outerHeight();
      }).get()
    );
  
  
    items.each(function () {
      $(this).outerHeight(maxHeight);
    });
  
}
  
  
$(window).on('resize', function () {
    eqHeight() 
});

$(document).on('click', '.rbm_js_execute_compare', function (e, i) {
    filter($(".rbm_js_hide_equal").val());
});



$('[name="compare_category"]').prop('selectedIndex', 0).niceSelect('update').trigger('change');
